import useCommonStore from 'store/useCommonStore';
import { apis } from 'apis/apis';
import { ILoginData, ISetPasswordEmail } from 'apis/user_apis';
import axios from 'axios';
import useToast from 'hooks/useToast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { IErrRes } from 'type/db';
import { CookieSetOptions } from 'universal-cookie';
import { removeCookie, setCookie } from 'utils/cookies';

// 로그인
export const useLoginMutation = <T>(persistent: boolean, options?: T) => {
	const navigate = useNavigate();
	const toast = useToast();
	return useMutation((login_data: ILoginData) => apis.login(login_data), {
		onSuccess: (data) => {
			const option: CookieSetOptions = {
				path: '/',
			};
			if (persistent) option.maxAge = 60 * 60 * 24 * 30;
			axios.defaults.headers.common[
				'Authorization'
			] = `Bearer ${data?.data.result.imms_access_token}`;
			setCookie('imms_access_token', data?.data.result.access_token, option);
			navigate(`/imms/rank`, { replace: true });
		},
		onError: (err: IErrRes) => {
			if (err.resultCode === 'invalid')
				toast('이메일 또는 비밀번호를 다시 확인하고 시도해주세요.', false, true);
			else toast('로그인에 실패했습니다.', false, true);
		},
		...options,
	});
};

// 로그아웃
export const useLogoutMutation = <T>(options?: T) => {
	const { setPlatform } = useCommonStore();
	const navigate = useNavigate();
	const toast = useToast();
	return useMutation(() => apis.logout(), {
		onSuccess: () => {
			setPlatform({ code: null, name: null });
			removeCookie('imms_access_token', { path: '/' });
			removeCookie('imms_workspace_code', { path: '/' });
			navigate('/imms/login', { replace: true });
			toast('로그아웃 되었습니다.');
		},
		onError: (err: IErrRes) => {
			toast('로그아웃에 실패했습니다.', false, true);
		},
		...options,
	});
};

/** 비밀번호 변경 이메일 전송 */
export const useSendPasswordEmailMutation = <T>(options?: T) => {
	return useMutation((email: string) => apis.sendPasswordEmail(email), {
		onError(err: IErrRes) {
			console.log(err);
		},
		...options,
	});
};

export const useSetPasswordEmailMutation = <T>(options?: T) =>
	useMutation(
		(data: ISetPasswordEmail) => apis.setPasswordEmail(data.uid, data.token, data),
		{
			onError(err: IErrRes) {
				console.log(err);
			},
			...options,
		},
	);
